define('controllers/admin/content',['require'],function(require) {
    return function() {
        Utilities.setDefaultButton($("#panelDelete"), $("#btnDeleteContent"));
        Utilities.setDefaultButton($("#panelUpload"), $("#btnUploadContent"));
    };
});

